{
  "title": "تسجيل الدخول",
  "subtitle": "سجّل الدخول إلى مساحة عمل شركتك.",
  "email": "البريد الإلكتروني",
  "password": "كلمة المرور",
  "submit": "تسجيل الدخول",
  "submitting": "جارٍ تسجيل الدخول…",
  "showPassword": "إظهار كلمة المرور",
  "hidePassword": "إخفاء كلمة المرور",
  "help": "نسيت كلمة المرور؟ اطلب من مسؤول النظام إعادة تعيينها.",
  "errors": {
    "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة. تحقق منهما وحاول مرة أخرى.",
    "locked": "محاولات فاشلة كثيرة. هذا الحساب مقفل لبضع دقائق — حاول لاحقًا.",
    "rateLimited": "محاولات دخول كثيرة من هذه الشبكة. انتظر دقيقة وحاول مرة أخرى.",
    "invalidInput": "أدخل بريدك الإلكتروني وكلمة المرور."
  },
  "changePassword": {
    "title": "تغيير كلمة المرور",
    "subtitle": "اختر كلمة مرور جديدة لحسابك.",
    "forcedTitle": "غيّر كلمة المرور",
    "forcedNoticeTitle": "عيّن مسؤول النظام كلمة المرور الحالية",
    "forcedNotice": "اختر كلمة مرور جديدة لا يعرفها أحد غيرك. تبقى بقية الشاشات مقفلة حتى تفعل ذلك.",
    "current": "كلمة المرور الحالية",
    "new": "كلمة المرور الجديدة",
    "confirm": "تأكيد كلمة المرور الجديدة",
    "strengthHint": "10 أحرف على الأقل. بضع كلمات غير مترابطة تصنع كلمة مرور قوية يسهل تذكرها.",
    "show": "إظهار كلمات المرور",
    "otherSessions": "ستبقى متصلًا هنا، وسيُسجَّل خروجك من الأجهزة والمتصفحات الأخرى.",
    "submit": "تغيير كلمة المرور",
    "signOut": "تسجيل الخروج",
    "mismatch": "كلمتا المرور غير متطابقتين. اكتب كلمة المرور الجديدة مرة أخرى.",
    "currentWrong": "كلمة المرور الحالية غير صحيحة.",
    "failed": "لم تُغيَّر كلمة المرور",
    "done": "تم تغيير كلمة المرور",
    "doneBody": "سُجّل خروجك من جلساتك الأخرى."
  },
  "invitation": {
    "title": "عيّن كلمة المرور",
    "subtitle": "أهلًا {{name}}. اختر كلمة مرور لتسجيل الدخول إلى {{company}}.",
    "checking": "جارٍ التحقق من رابط الدعوة…",
    "password": "كلمة المرور الجديدة",
    "confirm": "اكتبها مرة أخرى",
    "expires": "يعمل هذا الرابط حتى {{date}}.",
    "submit": "تعيين كلمة المرور",
    "submitting": "جارٍ تعيين كلمة المرور…",
    "failed": "لم تُعيَّن كلمة المرور",
    "invalidTitle": "انتهت صلاحية هذا الرابط أو سبق استخدامه",
    "invalidBody": "روابط الدعوة تعمل مرة واحدة ولمدة 3 أيام. اطلب من المسؤول الذي دعاك إرسال رابط جديد.",
    "toSignIn": "الانتقال إلى تسجيل الدخول",
    "doneTitle": "عُيّنت كلمة المرور",
    "doneBody": "يمكنك الآن تسجيل الدخول بعنوان بريدك الإلكتروني وكلمة المرور التي اخترتها.",
    "signIn": "تسجيل الدخول"
  }
}
